/**
 * A research's status named in the interface language. The enum itself
 * (DRAFT / ACTIVE / …) stays what the API sends and what the CSS class is
 * built from — only the badge's text passes through here.
 */
import i18n from 'i18next';

const KEYS: Record<string, string> = {
  DRAFT: 'statusDraft',
  ACTIVE: 'statusActive',
  PAUSED: 'statusPaused',
  COMPLETED: 'statusCompleted',
  ARCHIVED: 'statusArchived',
};

export const researchStatusLabel = (status?: string | null): string => {
  const key = KEYS[(status || '').toUpperCase()];
  return key ? i18n.t(`research.${key}`) : (status || '');
};
